<main class="event-page">
  @if (loading()) {
    <section class="state-card container">Chargement de l'évènement…</section>
  } @else if (notFound()) {
    <section class="state-card container">
      <h1>Évènement introuvable</h1>
      <p>Cet évènement n'est plus disponible ou n'a pas encore été publié.</p>
      <a routerLink="/">← Retour à l'accueil</a>
    </section>
  } @else if (event(); as item) {
    <section class="event-hero">
      <div class="container hero-grid">
        <div>
          <p class="eyebrow">AGBE · ÉVÈNEMENT</p>
          <h1>{{ localized('title') }}</h1>
          <p class="lead">{{ localized('info') }}</p>
          <div class="event-meta">
            @if (eventDate()) { <span>📅 {{ eventDate() }}</span> }
            @if (item.location) { <span>📍 {{ item.location }}</span> }
          </div>
        </div>
        @if (item.logo_url) { <div class="hero-mark"><img [src]="mediaUrl(item.logo_url)" [alt]="'Logo ' + localized('title')" (error)="hideBrokenImage($event)" /></div> }
      </div>
    </section>

    <section class="event-body container">
      <article class="event-intro-card">
        @if (isTombola()) {
          <p class="kicker">Tombola Solidaire Maranatha 2026</p>
          <h2>Un gala solidaire au service des bourses FEIAC</h2>
          <p>{{ localized('description') }}</p>
          <p>La Tombola Solidaire Maranatha contribue au financement de bourses destinées à des étudiants camerounais. Le formulaire d'inscription et de participation HelloAsso est intégré directement ci-dessous afin de conserver un parcours fluide sur le site AGBE.</p>
        } @else {
          <p class="kicker">ÉVÈNEMENT AGBE</p>
          <h2>{{ localized('title') }}</h2>
          <p>{{ localized('description') }}</p>
        }
      </article>

      @if (embedUrl()) {
        <section class="helloasso-card" id="participer">
          <div class="section-heading">
            <div>
              <p class="kicker">INSCRIPTION & PARTICIPATION</p>
              <h2>Participez via HelloAsso</h2>
            </div>
            <span class="secure-badge">Paiement sécurisé</span>
          </div>
          @if (!iframeLoaded()) { <div class="embed-loading">Chargement du formulaire sécurisé…</div> }
          <iframe
            title="Formulaire HelloAsso de l'évènement"
            [src]="embedUrl()"
            (load)="iframeLoaded.set(true)"
            scrolling="yes"
            loading="eager"
            referrerpolicy="strict-origin-when-cross-origin">
          </iframe>
          <p class="external-help">Si le formulaire ne s'affiche pas correctement, <a [href]="item.registration_url" target="_blank" rel="noopener noreferrer">ouvrez la billetterie HelloAsso</a>.</p>
        </section>
      }
    </section>
  }
</main>
